/* eslint-disable */
export const maxLifetime = 15

export default [
  [0, 100000],
  [1, 55000],
  [2, 41250],
  [3, 32588],
  [4, 26396],
  [5, 20853],
  [6, 17099],
  [7, 14021],
  [8, 10095],
  [9, 5956],
  [10, 3574],
  [11, 2216],
  [12, 1396],
  [13, 893],
  [14, 563],
  [15, 169],
  [16, 0]
]
